// 导入 axios
import axios from 'axios'
/*ElementUI*/
import ele from 'element-ui'
// vuex
import store from '../store/index.js'
import router from '../router/index.js'

// 默认请求格式
axios.defaults.headers['Content-Type'] = 'multipart/form-data';
// 创建 axios 实例
const  urldownload = axios.create({
    baseURL: '/downloadapi', // 基础url,如果是多环境配置这样写，也可以像下面一行的写死。
    // baseURL: 'http://168.192.0.123',
    //timeout: 6000 // 请求超时时间
})

// 退出登录
  function exit() {
	  // 清除Token
	  localStorage.removeItem("Authorization");
	  // 清除存储用户信息
	  localStorage.removeItem("member");
	  // 清除登录
	  localStorage.removeItem("isLogin");
	  router.push('/login');
  }

// 错误处理函数
const err = (error) => {
	
    return Promise.reject(error)
}

// request interceptor(请求拦截器)
urldownload.interceptors.request.use(config => {
    const token = localStorage.getItem('Authorization');
    if (token) {
        config.headers['Authorization'] = token // 让每个请求携带自定义 token
    }
	config.headers['InterfaceToken'] = store.state.InterfaceToken; // 接口通行证
	config.headers['Language'] = store.state.lang;
    return config
}, err)

// response interceptor（接收拦截器）
urldownload.interceptors.response.use(response => {
    return response;
}, err)

export default urldownload